import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const Snaks = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/makmenu' name='Снеки'/>
            <main className={s.main}>
                <Product name='Курячі крила' price='110 грн.' weight='200г.' info1='Курячі крила'/>
                <Product name='Картопля фрі (з кетчупом)' price='50 грн.'  weight='130г.' info1='Картопля фрі'/>
                <Product name='Соуси' price='10 грн.'  weight='30г.' info1='сирний, до піци, кетчуп, барбекю, тартар, вершковий, чилі, цезар, кисло-солодкий, медово-гірчичний, часниковий, майонез'/>
                <Product name='Корн-дог з сосискою' price='45 грн.'  weight='80г.' info1='Корн-дог з сосискою'/>
                <Product name='Сирні палички' price='120 грн.'  weight='150г.' info1='Сирні палички'/>
                <Product name='Сосиска в спіральній чіпсі' price='60 грн.'  weight='80г.' info1='Сосиска в спіральній чіпсі'/>
                <Product name='Кільця кальмара' price='120 грн.'  weight='100г.' info1='Кільця кальмара'/>
                <Product name='Нагетси' price='100 грн.'  weight='100г.' info1='Нагетси'/>
                <Product name='Сирні кульки' price='110 грн.'  weight='150г.' info1='Сирні кульки'/>
                <Product name='Сосиска в спіральный чыпсі' price='60 грн.'  weight='80г.' info1='Сосиска в спіральный чыпсі'/>
                <Product name='Спіральні чіпси' price='50 грн.'  weight='50г.' info1='Спіральні чіпси'/>
                <Product name='Креветка в паніровці' price='110 грн.'  weight='100г.' info1='Креветка в паніровці'/>
            </main>
        </div>
    )
}

export default Snaks;